import './legacy_jquery'

(() => {
    'use strict'

    const getPreferredTheme = () => {
        const html = document.querySelector('#current-theme')
        if (html){
            return html.getAttribute('data-preferred-theme')
        } else {
            return 'auto'
        }
    }

    const setTheme = theme => {
        if (theme === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            document.documentElement.setAttribute('data-bs-theme', 'dark')
        } else {
            document.documentElement.setAttribute('data-bs-theme', theme)
        }
    }

    window.setTheme = setTheme

    // setTheme(getPreferredTheme())

    window.addEventListener('DOMContentLoaded', () => {
        setTheme(getPreferredTheme())
    })

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
        setTheme(getPreferredTheme())
    })

    $('body').on('change', '#current-theme', function (event){
        let usertheme = event.target.dataset.usertheme;
        document.documentElement.setAttribute("data-bs-theme", usertheme);
    })


})()